import React from 'react';
import PropTypes from 'proptypes';
import classnames from 'classnames';
import { Link } from 'react-router-dom';

import { ImageComponent as Image } from 'components/image';
import { CardBackgroundComponent as Card } from 'components/cards';
import { IconComponent as Icon } from 'components/icon';

import starIcon from 'static/icons/svg/star.svg';

const styles = require('./testimonial-component.styles.scss');


export class TestimonialComponent extends React.Component {
  static propTypes = {
    avatar: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    rating: PropTypes.oneOf([1, 2, 3, 4, 5]).isRequired,
    src: PropTypes.string,
    srcIcon: PropTypes.shape({
      boxView: PropTypes.string,
      id: PropTypes.string,
    }),
    date: PropTypes.string,
    maxRating: PropTypes.number,
  }

  static defaultProps = {
    maxRating: 5,
    src: '',
  }

  render() {
    return (
      <Card className={styles.Testimonial}>
        { this.renderCardContent() }
      </Card>
    );
  }

  renderCardContent() {
    const { src } = this.props;
    const externalLink = src.startsWith('http') || src.startsWith('mailto');

    if (src && externalLink) {
      return (
        <a className={styles.Link} href={src} target='_blank'>
          { this.cardContent }
        </a>
      );
    } else if (src) {
      return (
        <Link className={styles.Link} to={src}>{ this.cardContent }</Link>
      );
    } else {
      return this.cardContent;
    }
  }

  get cardContent() {
    const { srcIcon, avatar, name, rating, children, date, maxRating } = this.props;

    return (
      <React.Fragment>
        <div className={styles.Row}>
          {
            srcIcon ? <Icon src={srcIcon} className={styles.SourceIcon} /> : null
          }
          <Image
            className={styles.Avatar}
            src={avatar}
            alt={name}
            width={45}
            round={true} />
          <div className={styles.TitleLine}>
            <h4 className={styles.Name}>{ name }</h4>
            <span className={styles.Rating}>
              { this.calculateRating(rating, maxRating) }
            </span>
            {
              date ? <span className={styles.Date}>{ date }</span> : null
            }
          </div>
        </div>
        <div className={classnames(styles.Row, styles.FlexRow)}>
          <p className={styles.Text}>{ children }</p>
        </div>
      </React.Fragment>
    );
  }

  calculateRating(raiting, maxRating) {
    const stars = [];

    for (let i=0; i<maxRating; i++) {
      const classname = i < raiting ? styles.FilledStar : styles.Star;
      stars.push(<Icon key={i} src={starIcon} className={classname} />)
    }

    return stars;
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/testimonial/testimonial.component.jsx